export { default } from './BubblesInTabs';
